module.exports = __webpack_public_path__ + "static/media/bitbucket.3ddba5ec.svg";